module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurLarge/Myths&Monsters.788733f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurLarge/Myths&Monsters.jpg
// module id = pL8k
// module chunks = 0